import React, { Component } from "react";
import { Col, Row, Card, CardBody, CardHeader } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { string, func } from "prop-types";
import { Link } from "react-router-dom";
import TableContainerWithLocation from "../../Components/TableContainerWithLocation";
import { khrViewFormatter } from "../../../util/formatter";

const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

class LimitTemplate extends Component {
  static propTypes = {
    header: string.isRequired,
    requestApi: func.isRequired,
  };

  editLink = (cell, row) => {
    return (
      <Link
        to={{
          pathname: `/kyc-limit-edit/${row.id}`,
          state: { data: row },
        }}>
        <div>
          <i
            className="fa fa-search"
            style={{ color: "#D15050" }}
            data-cy="edit-limit"
          />
        </div>
      </Link>
    );
  };

  render() {
    const { header, requestApi, requestReport } = this.props;

    return (
      <div>
        <Row>
          <Col>
            <Card>
              <CardHeader>{header}</CardHeader>
              <CardBody>
                <TableContainerWithLocation
                  loadData={requestApi}
                  requestReport={requestReport}
                  reportWithoutDateRange>
                  <BootstrapTable
                    headerStyle={headerStyle}
                    version="4"
                    pagination
                    striped
                    hover
                    condensed
                    remote
                    tableBodyClass="custom-select-body-class"
                    exportCSV>
                    <TableHeaderColumn
                      dataFormat={this.editLink}
                      width="30"
                      dataAlign="center">
                      Edit
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="limitName"
                      width="150"
                      dataAlign="center"
                      isKey>
                      Limit name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="limits"
                      dataFormat={value =>
                        khrViewFormatter(value["khr#nbc"].dayLimit)
                      }
                      dataAlign="right"
                      width="80">
                      KHR limit
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="limits"
                      dataFormat={value =>
                        khrViewFormatter(value["usd#nbc"].dayLimit)
                      }
                      dataAlign="right"
                      width="80">
                      USD limit
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="kycStatus"
                      dataAlign="center"
                      width="100">
                      KYC Status
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="description"
                      dataAlign="center"
                      width="100">
                      Description
                    </TableHeaderColumn>
                  </BootstrapTable>
                </TableContainerWithLocation>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default LimitTemplate;
